<script lang="ts">
    import type {AuthorityDetailReactivePageData, AuthorityDetailStaticPageData} from '../types';
    import {getPageContext} from 'shared/layouts/page-context';
    import RecordPermalink from '../../record-permalink/RecordPermalink.svelte';

    const pageContext = getPageContext<AuthorityDetailStaticPageData, AuthorityDetailReactivePageData>();
    const model = pageContext.staticData.model;
</script>

<RecordPermalink record={model.record}/>